import React, { Fragment } from "react";
import { createPortal } from "react-dom";
const Backdrop = ({ onBackdropClicked }) => (
  <div className="backdrop" onClick={onBackdropClicked} />
);
const Modal = ({ children, onBackdropClicked }) => {
  return (
    <Fragment>
      {createPortal(
        <Backdrop onBackdropClicked={onBackdropClicked} />,
        document.getElementById("backdrop-root")
      )}
      {createPortal(
        <div
          className="overlay"
          onAnimationEnd={() => console.log("on animation end")}
        >
          {children}
        </div>,
        document.getElementById("overlay-root")
      )}
    </Fragment>
  );
};

export default Modal;
